import React from 'react';

/**
 * UserAvatar - Displays a user's profile picture or a fallback with their initial
 *
 * @param {Object} props
 * @param {string} props.displayName - User's display name (used for initial fallback)
 * @param {string} props.avatarUrl - URL to the user's avatar image (optional)
 * @param {string} props.size - Size variant: 'xs', 'sm', 'md', 'lg', 'xl' (default: 'md')
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.isGM - Whether the user is a GM (uses primary color for fallback)
 */
export const UserAvatar = ({
  displayName,
  avatarUrl,
  size = 'md',
  className = '',
  isGM = false,
}) => {
  const sizeClasses = {
    xs: 'w-5 h-5 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl',
  };

  const bgColor = isGM ? 'bg-primary-100' : 'bg-gray-200';
  const textColor = isGM ? 'text-primary-600' : 'text-gray-500';

  const initial = displayName?.[0]?.toUpperCase() || '?';

  return (
    <div
      className={`
        ${sizeClasses[size] || sizeClasses.md}
        rounded-full flex items-center justify-center overflow-hidden flex-shrink-0
        ${!avatarUrl ? bgColor : ''}
        ${className}
      `}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt={displayName || 'User avatar'}
          className="w-full h-full object-cover"
        />
      ) : (
        <span className={`font-medium ${textColor}`}>
          {initial}
        </span>
      )}
    </div>
  );
};
